import dayjs from 'dayjs';

import type { Dayjs } from 'dayjs';

const getValidDate = (isoDate: string | null): Dayjs | null => {
  if (!isoDate) return null;

  const date = dayjs(isoDate);

  return date.isValid() ? date : null;
};

export const formatLeadRegistryTime = (
  isoDate: string | null
): string | null => {
  if (!isoDate) return null;

  const target = dayjs(isoDate);

  if (!target.isValid()) return null;

  const now = dayjs();

  if (target.isSame(now, 'day')) {
    return target.format('HH:mm');
  }

  if (target.isSame(now.subtract(1, 'day'), 'day')) {
    return `Вчера ${target.format('HH:mm')}`;
  }

  if (target.isSame(now, 'year')) {
    return target.format('D MMM');
  }

  return target.format('DD.MM.YYYY');
};

export const formatLeadRegistryDateTime = (
  isoDate: string | null
): string | null => {
  if (!isoDate) return null;

  const target = dayjs(isoDate);

  if (!target.isValid()) return null;

  return target.format('DD.MM.YY HH:mm');
};

export const formatLeadRegistryTaskPeriod = (
  start: string | null,
  deadline: string | null
): string => {
  const startDate = getValidDate(start);
  const deadlineDate = getValidDate(deadline);

  if (!startDate && !deadlineDate) return '';

  const isFullDayTask =
    startDate &&
    deadlineDate &&
    startDate.format('HH:mm') === '00:00' &&
    (deadlineDate.format('HH:mm') === '23:59' ||
      deadlineDate.format('HH:mm') === '00:00');

  const format = isFullDayTask ? 'DD.MM.YYYY' : 'DD.MM.YYYY HH:mm';
  const startLabel = startDate ? startDate.format(format) : null;
  const deadlineLabel = deadlineDate ? deadlineDate.format(format) : null;

  if (startLabel && deadlineLabel) {
    return `${startLabel} - ${deadlineLabel}`;
  }

  return startLabel ?? deadlineLabel ?? '';
};
